import router from "./router";
import store from "./store";
import firebase from './firebase';
import Cookies from "js-cookie";

// Connect Analytics
const fireAnalytics = firebase.analytics();

// Default Token Data
let tokenData = {
  token: false,
  refresh_token: false,
}

router.beforeEach((to, from, next) => {
  const tracking_cookie_exists = Cookies.get("tracking");
  if (tracking_cookie_exists) {
    fireAnalytics.logEvent("page_view", {screen_name: to.name});
  }

  // Scroll to top on route change
  window.scrollTo(0, 0);

  // Get active language if any
  const language = Cookies.get("language");
  if (language) {
    store.dispatch('SetActiveLanguage', language);
  } else {
    store.dispatch('SetActiveLanguage', 'br');
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Authenticated Route
    if (Cookies.get("refresh_token") == null) {
      store.dispatch('SetLoggedIn', false);
      window.location.href = "/login";
    } else {

      tokenData.token = Cookies.get("token");
      tokenData.refresh_token = Cookies.get("refresh_token");

      if (tokenData.refresh_token) {
        store.dispatch('SetToken', tokenData);
        store.dispatch('SetLoggedIn', true)
      }

      next()
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    // Guest Route
    let tokenData = {
      token: false,
      refresh_token: false,
    }

    tokenData.token = Cookies.get("token");
    tokenData.refresh_token = Cookies.get("refresh_token");

    if (tokenData.refresh_token) {
      store.dispatch('SetToken', tokenData);
      store.dispatch('SetLoggedIn', true)
    }

    next()
  } else {
    // Open Route
    next();
  }
});

export default router;
